import { TradingHour, ParsedOpeningHour } from './types'
import { stripStatus } from './strip-status'
import { parseCentreOrLinkedStoreHours } from './parse-centre-or-linked-store-hours'

export function parseServiceHours(
  centreTradingHours: TradingHour[],
  centreTimeZone: string
): ParsedOpeningHour[] {
  return stripStatus(
    parseCentreOrLinkedStoreHours(centreTradingHours, centreTimeZone, [])
  )
}
